// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sLrr","content":"styles_content__3M71e","tableWrap":"styles_tableWrap__1i505"};